export function validQuantity(value, { min = 1, max = Number.MAX_SAFE_INTEGER, step = 1 } = {}) {
  const q = Number(value);
  return /^\d+$/.test(String(value)) && Number.isSafeInteger(q) && q >= min && q <= max && (q - min) % step === 0;
}

export function quote({ unit, quantity, existing = 0, productId, variantId, currency, country, config, now, compare = 0 }) {
  if (!validQuantity(quantity) || !Number.isSafeInteger(existing) || existing < 0 || !Number.isSafeInteger(unit) || unit < 0 || !Number.isSafeInteger((quantity + existing) * unit)) throw Error('Invalid quantity or amount');
  const age = now - Date.parse(config?.verifiedAt);
  const verified = Boolean(config && Number.isFinite(age) && age >= 0 && config.currency === currency && config.country === country && String(config.productId) === String(productId) && String(config.variantId) === String(variantId) && config.baseMinor === unit && config.rules?.length === 3);
  const eligible = quantity + existing;
  let perDevice = unit;
  let usable = verified;
  for (const rule of config?.rules || []) {
    const active = rule.status === 'ACTIVE' && rule.oneTime && rule.buyer === 'all' && now >= Date.parse(rule.startsAt) && (!rule.endsAt || now < Date.parse(rule.endsAt));
    if (!active) usable = false;
  }
  if (usable) for (const rule of config.rules) {
    if (eligible < rule.minimum) continue;
    const discount = rule.type === 'percentage' ? Math.round(unit * rule.basisPoints / 10000) : rule.type === 'fixed' && rule.currency === currency && rule.each ? rule.amountMinor : NaN;
    if (!Number.isSafeInteger(discount) || discount < 0 || discount > unit) { usable = false; break; }
    perDevice = Math.min(perDevice, unit - discount);
  }
  if (!usable) perDevice = unit;
  return { verified: usable, quantity, eligible, total: perDevice * quantity, perDevice, savings: (unit - perDevice) * quantity, combined: perDevice * eligible, compare: Number.isSafeInteger(compare) && compare > unit ? compare * quantity : null };
}

export function campaignState(config, now) {
  if (!Number.isFinite(now) || !config || config.timezone !== 'America/Los_Angeles') return 'unconfigured';
  if (now >= Date.parse('2026-12-26T00:00:00-08:00')) return 'ended';
  const cutoff = Date.parse(config.cutoff);
  if (!Number.isFinite(cutoff) || !/[+-]\d\d:\d\d$/.test(config.cutoff || '') || cutoff > Date.parse('2026-12-01T00:00:00-08:00')) return 'unconfigured';
  if (now >= cutoff) return 'expired';
  return config.enabled && config.scheduleVerified && config.policyVerified && config.balanceDate === '2026-12-01' && config.shipBy === '2026-12-25' ? 'active' : 'unconfigured';
}

export function reservationAmounts(unit, quantity, basisPoints = 1000) {
  if (!validQuantity(quantity) || !Number.isSafeInteger(unit) || unit < 0 || basisPoints !== 1000 || !Number.isSafeInteger(unit * quantity)) throw Error('Invalid reservation');
  const total = unit * quantity;
  const deposit = Math.round(unit * basisPoints / 10000) * quantity;
  return { total, deposit, balance: total - deposit };
}
